import styled from 'styled-components'

export const Container = styled.div`
    background: #f9f9f9;
    border: 2px solid #7e7d7a;
    border-radius: 10px;
    padding: 10px;

    h1 {
        font-size: 32px;
        font-weight: bold;
        color: #002666;
        margin: 5px;
        padding: 0;

        i {
            color: #212429;
            font-size: 54px;
        }
    }
`

export const Bar = styled.div`
    border: 2px solid #d8e0ea;
    width: 100%;
`

export const Body = styled.div`
    padding: 5px;
`
